import Flex from "../../../../designComponents/Flex";
import Typography from "../../../../designComponents/Typography";
import { ICommonSpace, IUnit } from "./types";

type Props = {
  title: string;
  units: IUnit[];
  commonSpace: ICommonSpace[];
  propertyType: string;
  berRating: string;
  propertyCreationType: string;
  furnishedType: string;
  rentalMarket: string;
  bedrooms: number;
  bathrooms: number;
  area: number;
  availableDate: number;
};

const PropertyBasicInformationViewer = ({
  area,
  availableDate,
  bathrooms,
  bedrooms,
  berRating,
  furnishedType,
  propertyCreationType,
  propertyType,
  rentalMarket,
  title,
  units,
  commonSpace,
}: Props) => {
  const dataObject = [
    { label: "Title", value: title },
    { label: "Area", value: area },
    { label: "Available Date", value: availableDate },
    { label: "Bathrooms", value: bathrooms },
    { label: "Bedrooms", value: bedrooms },
    { label: "BER Rating", value: berRating },
    { label: "Furnished Type", value: furnishedType },
    { label: "Property Creation Type", value: propertyCreationType },
    { label: "Property Type", value: propertyType },
    { label: "Rental Market", value: rentalMarket },
  ].filter(
    (item) =>
      item.value !== undefined && item.value !== null && item.value !== ""
  );
  return (
    <div>
      {dataObject?.map(({ label, value }) => {
        return (
          <Flex key={label}>
            <Typography fontWeight="bold">{label}</Typography>
            <Typography>{value}</Typography>
          </Flex>
        );
      })}
      <Typography fontWeight="bold">Rooms</Typography>
      {units?.map((u) => {
        return (
          <Flex
            key={u._id}
            direction="column"
            style={{ backgroundColor: "#f0f0f0" }}
            gap={"4px"}
            margin={"0px 0px 10px 0px"}
            padding={"10px"}
          >
            <Flex>
              <Typography fontWeight="bold">Title</Typography>
              <Typography>{u.title}</Typography>
            </Flex>
            <Flex>
              <Typography fontWeight="bold">Rent</Typography>
              <Typography>{u.rent}</Typography>
            </Flex>
            <Flex>
              <Typography fontWeight="bold">Status</Typography>
              <Typography>{u.status}</Typography>
            </Flex>
            <Flex>
              <Typography fontWeight="bold">Description</Typography>
              <Typography>{u.description}</Typography>
            </Flex>
            <Flex>
              <Typography fontWeight="bold">Images</Typography>
              <Flex gap={"20px"}>
                {u.images?.map((i) => {
                  return (
                    <img
                      src={i}
                      alt="unit"
                      style={{ height: "180px", width: "220px" }}
                    />
                  );
                })}
              </Flex>
            </Flex>
          </Flex>
        );
      })}

      <Typography fontWeight="bold">Common Space</Typography>
      {commonSpace?.length <= 0 || !commonSpace ? "N/A" : ""}
      {commonSpace?.map((cs) => {
        return (
          <Flex
            key={cs._id}
            direction="column"
            style={{ backgroundColor: "#f0f0f0" }}
            gap={"4px"}
            margin={"0px 0px 10px 0px"}
            padding={"10px"}
          >
            <Flex>
              <Typography fontWeight="bold">Title</Typography>
              <Typography>{cs.title}</Typography>
            </Flex>
            <Flex>
              <Typography fontWeight="bold">Description</Typography>
              <Typography>{cs.description}</Typography>
            </Flex>
            <Flex>
              <Typography fontWeight="bold">Images</Typography>
              <Flex gap={"20px"}>
                {cs.images?.map((i) => {
                  return (
                    <img
                      src={i}
                      alt="unit"
                      style={{ height: "180px", width: "220px" }}
                    />
                  );
                })}
              </Flex>
            </Flex>
          </Flex>
        );
      })}
    </div>
  );
};

export default PropertyBasicInformationViewer;
